<template>
  <!--产线 MTTR-->
  <dv-border-box-13>
    <div class="item" :style="{ height: col + 'vh' }">
      <div class="font-weight font-s">{{ title }}</div>
      <div id="PLMTTRechart" style="height: 100%; width: 100%"></div>
    </div>
  </dv-border-box-13>
</template>

<script>
export default {
  name: "andon-product-line-mttr",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    mttr: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headTitle: {
      type: String,
      default: function () {
        return "MTTR";
      },
    },
  },
  data() {
    return {
      title: this.headTitle,
      mttrs: this.mttr,
      platosMttr: undefined,
    };
  },
  watch: {
    mttr: {
      handler: function (val, oldVal) {
        this.mttrs = val;
        this.mttrEchart();
      },
      deep: true,
    },
  },
  mounted() {
    var _this = this;
  },
  methods: {
    mttrEchart() {
      var _this = this;
      var dataSet = _this.mttrs;

      let daset = [];
      let daval = [];
      let falt = [];
      dataSet.forEach((m) => {
        if (m["period"] != "其他") {
          var count = m["issueCount"];
          var reported = m["reported"];
          var data = "0";
          if (count > 0) {
            data = (reported / (1000 * 60) / count).toFixed(2);
          }
          daset.push(m["period"]);
          daval.push(data);
          falt.push(m["kpi"]);
        }
      });

      var echart = this.$echarts.init(document.getElementById("PLMTTRechart"));

      var option = {
        grid: {
          bottom: "50",

          x: 50,
          y: 10,
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["MTTR"],
          textStyle: {
            color: "#ffffff",
          },
        },
        xAxis: [
          {
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: daset,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              interval: 0,
              rotate: 40,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            splitNumber: 5,
            axisLabel: {
              formatter: "{value} m",
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: 12,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            color: ["#3398DB"],
            name: "实际",
            type: "bar",
            data: daval,
            barGap: "-100%",
          },
          {
            name: "目标",
            type: "line",
            data: falt,
            smooth: true,
            itemStyle: {
              normal: {
                label: {
                  show: false, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#fff",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      echart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        echart.resize();
      });

      if (_this.platosMttr) {
        clearInterval(_this.platosMttr);
      }

      var index = 0; //显示tooltip,播放所在下标
      _this.platosMttr = setInterval(function () {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= daset.length) {
          index = 0;
        }
      }, 2000);
    },
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.2rem 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/production-mttr.vue